import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const FeePaymentDetailsEditLazy = React.lazy(
	() => import(/* webpackChunkName : 'FeePaymentDetailsEdit' */ './components')
);

export default (store) => [
	{
		path: 'home/fees/fee-payment/:studentId/edit',
		element: <AsyncLoading component={<FeePaymentDetailsEditLazy />} />,
	},
];
